import React from 'react';
import { Users } from 'lucide-react';
import JuryCard from './JuryCard';

const JuryList = ({ 
  jurys, 
  loading, 
  searchTerm, 
  onEdit, 
  onDelete, 
  onViewDetails, 
  onAddNew 
}) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="animate-pulse">
              <div className="flex items-center space-x-3 mb-4">
                <div className="bg-gray-200 h-10 w-10 rounded-lg"></div>
                <div className="flex-1">
                  <div className="bg-gray-200 h-4 rounded mb-2"></div>
                  <div className="bg-gray-200 h-3 rounded w-2/3"></div>
                </div>
              </div>
              <div className="space-y-3">
                <div className="bg-gray-200 h-16 rounded-lg"></div>
                <div className="bg-gray-200 h-20 rounded-lg"></div>
                <div className="flex justify-between">
                  <div className="bg-gray-200 h-6 w-20 rounded-full"></div>
                  <div className="bg-gray-200 h-4 w-24 rounded"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (jurys.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="bg-gray-100 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
          <Users className="h-10 w-10 text-gray-400" />
        </div>
        <h3 className="text-xl font-medium text-gray-900 mb-2">
          {searchTerm ? 'Aucun jury trouvé' : 'Aucun jury constitué'}
        </h3>
        <p className="text-gray-500 mb-6 max-w-md mx-auto">
          {searchTerm 
            ? `Aucun jury ne correspond à votre recherche "${searchTerm}". Essayez avec d'autres mots-clés.`
            : 'Commencez par constituer votre premier jury de soutenance.'
          }
        </p>
        {!searchTerm && (
          <button
            onClick={onAddNew}
            className="bg-gradient-to-r from-purple-600 to-purple-700 text-white px-6 py-3 rounded-lg hover:from-purple-700 hover:to-purple-800 transition-all duration-200 inline-flex items-center space-x-2"
          >
            <Users className="h-5 w-5" />
            <span>Constituer un jury</span>
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {jurys.map((jury) => (
        <JuryCard
          key={jury.id}
          jury={jury}
          onEdit={onEdit}
          onDelete={onDelete}
          onViewDetails={onViewDetails}
        />
      ))}
    </div>
  );
};

export default JuryList; 